var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2042_7253)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01489 4.62514C3.01489 4.42631 3.17607 4.26514 3.37489 4.26514H14.6249C14.8237 4.26514 14.9849 4.42631 14.9849 4.62514C14.9849 4.82396 14.8237 4.98514 14.6249 4.98514H3.37489C3.17607 4.98514 3.01489 4.82396 3.01489 4.62514Z",
    fill: "#525365"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93467 2.55992C7.28349 2.2111 7.75659 2.01514 8.24989 2.01514H9.74989C10.2432 2.01514 10.7163 2.2111 11.0651 2.55992C11.4139 2.90874 11.6099 3.38183 11.6099 3.87514V4.62514H10.8899V3.87514C10.8899 3.57279 10.7698 3.28283 10.556 3.06903C10.3422 2.85524 10.0522 2.73514 9.74989 2.73514H8.24989C7.94755 2.73514 7.65758 2.85524 7.44379 3.06903C7.23 3.28283 7.10989 3.57279 7.10989 3.87514V4.62514H6.38989V3.87514C6.38989 3.38183 6.58586 2.90874 6.93467 2.55992Z",
    fill: "#525365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 4.625V15.125C13.875 15.5228 13.717 15.9044 13.4357 16.1857C13.1544 16.467 12.7728 16.625 12.375 16.625H5.625C5.22717 16.625 4.84564 16.467 4.56434 16.1857C4.28304 15.9044 4.125 15.5228 4.125 15.125V4.625",
    fill: "#525365"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48489 4.625V15.125C4.48489 15.4273 4.605 15.7173 4.81879 15.9311C5.03258 16.1449 5.32255 16.265 5.62489 16.265H12.3749C12.6772 16.265 12.9672 16.1449 13.181 15.9311C13.3948 15.7173 13.5149 15.4273 13.5149 15.125V4.625H14.2349V15.125C14.2349 15.6183 14.0389 16.0914 13.6901 16.4402C13.3413 16.789 12.8682 16.985 12.3749 16.985H5.62489C5.13159 16.985 4.65849 16.789 4.30967 16.4402C3.96086 16.0914 3.76489 15.6183 3.76489 15.125V4.625H4.48489Z",
    fill: "#525365"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5011 6.89014C10.6999 6.89014 10.8611 7.05131 10.8611 7.25014V14.0001C10.8611 14.199 10.6999 14.3601 10.5011 14.3601C10.3023 14.3601 10.1411 14.199 10.1411 14.0001V7.25014C10.1411 7.05131 10.3023 6.89014 10.5011 6.89014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50087 6.89014C7.69969 6.89014 7.86087 7.05131 7.86087 7.25014V14.0001C7.86087 14.199 7.69969 14.3601 7.50087 14.3601C7.30205 14.3601 7.14087 14.199 7.14087 14.0001V7.25014C7.14087 7.05131 7.30205 6.89014 7.50087 6.89014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2042_7253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ffae3cc02824c31f5e0e1cde34e4fdec.svg";
export { ForwardRef as ReactComponent };